export default __webpack_public_path__ + "static/media/vegetable_table@2x.7e2e244c.png";